import { Navigate, Outlet, useLocation } from "react-router";
import { authRoutes } from "app/router/auth/routes";
import type { UserRole } from "modules/auth/types";
import { getRoleHomePath } from "modules/auth/utils";
import { useAuth } from "modules/auth/useAuth";
import { PageLoadingFallback } from "shared/ui/PageLoadingFallback";

interface RequireAuthProps {
  allowedRoles?: readonly UserRole[];
}

export function RequireAuth({ allowedRoles }: RequireAuthProps) {
  const location = useLocation();
  const { isAuthenticated, isRestoring, user } = useAuth();

  if (isRestoring) {
    return <PageLoadingFallback minHeight="100vh" />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={authRoutes.login.path}
        replace
        state={{ from: location }}
      />
    );
  }

  if (user && allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={getRoleHomePath(user.role)} replace />;
  }

  return <Outlet />;
}
